import React from 'react'
import SplashScreen from '../component/SplashScreen/SplashScreen'

export default function Homepage() {
  return (
    <SplashScreen />
  )
}
